// extracted by mini-css-extract-plugin
module.exports = {"button":"followButton__button__2i4","bounceIn":"followButton__bounceIn__3qo","highlightWallMessage":"followButton__highlightWallMessage__34E"};